// This will be used in more than one Filter,
// so I am putting it here in a common classes folder.
export class Range {
  lower:any;
  upper: any;

  constructor (
    lower: any, 
    upper: any) {
      this.lower = lower;
      this.upper = upper;
  }
}
